import React from 'react';
import { useIntl } from 'react-intl';
import { StreamingEarningsSummary } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../common/types';
import { streamingSectionPath } from '../streamingPaths';
import { formatMonth } from '../streamingFormat';
import { streamingEarningsMessages as messages } from '../streamingEarningsMessages';
import { StreamingBlock } from '../parts/StreamingBlock';
import { EarningsSummaryBody } from '../parts/EarningsSummaryBody';

interface EarningsBlockProps {
  earnings: StreamingEarningsSummary;
  /** The kinds of source that report earnings, for the line of the empty card. */
  givenBy: readonly string[];
  days: number;
  onNavigate: (path: string) => void;
  onOpenCatalog: () => void;
}

/** The Earnings block of the overview (design b1; a member sees e2; Free sees the plan card). */
const EarningsBlockComponent: React.FC<EarningsBlockProps> = ({
  earnings,
  givenBy,
  days,
  onNavigate,
  onOpenCatalog,
}) => {
  const intl = useIntl();
  // A hidden block has nothing to open: the plan card has its own button to the upgrade prompt.
  const canOpen = !earnings.hidden && earnings.connected;
  return (
    <StreamingBlock
      title={intl.formatMessage(messages.title)}
      meta={
        earnings.months === null || earnings.hidden
          ? undefined
          : intl.formatMessage(messages.netPeriod, {
              start: formatMonth(intl, earnings.months.from),
              end: formatMonth(intl, earnings.months.to),
            })
      }
      moreLabel={canOpen ? intl.formatMessage(messages.seeEarnings) : undefined}
      onMore={canOpen ? () => onNavigate(streamingSectionPath('earnings', days)) : undefined}
      testId="streaming-block-earnings"
    >
      <EarningsSummaryBody earnings={earnings} givenBy={givenBy} onOpenCatalog={onOpenCatalog} />
    </StreamingBlock>
  );
};

export const EarningsBlock = TypedMemo(EarningsBlockComponent);
